import { DateTime } from "luxon";
import { min, max } from "./luxonHelpers";

/**
 * Calculate whether lunch and dinner should be provided based on shift times
 * @param {DateTime} startTime - Shift start time
 * @param {DateTime} endTime - Shift end time
 * @returns {{lunch: DateTime|null, dinner: DateTime|null}}
 */
export const calculateMeals = (startTime, endTime) => {
  if (!startTime || !endTime) return { lunch: null, dinner: null };

  const withinLunch = () => {
    const lunchStart = startTime.set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
    const lunchEnd = startTime.set({ hour: 15, minute: 0, second: 0, millisecond: 0 });
    const shiftHours = endTime.diff(startTime, "hours").hours;
    let hoursInLunchPeriod;

    if (
      (startTime >= lunchStart && startTime < lunchEnd) ||
      (lunchStart >= startTime && lunchStart < endTime)
    ) {
      if (shiftHours >= 10) return lunchStart;

      hoursInLunchPeriod = min(lunchEnd, endTime).diff(max(lunchStart, startTime), "hours").hours;
      if (hoursInLunchPeriod * 2 >= shiftHours) return lunchStart;
    }

    const secondLunchStart = lunchStart.plus({ days: 1 });
    if (secondLunchStart >= startTime && secondLunchStart < endTime) {
      if (shiftHours >= 10) return lunchStart;

      const secondLunchEnd = lunchEnd.plus({ days: 1 });
      hoursInLunchPeriod = min(secondLunchEnd, endTime).diff(secondLunchStart, "hours").hours;
      if (hoursInLunchPeriod * 2 >= shiftHours) return secondLunchStart;
    }

    return null;
  };

  const withinDinner = () => {
    const lunchStart = startTime.set({ hour: 15, minute: 0, second: 0, millisecond: 0 });
    let lunchEnd = endTime.set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
    const shiftHours = endTime.diff(startTime, "hours").hours;

    if (startTime.hasSame(endTime, "day")) {
      lunchEnd = lunchEnd.endOf("day");
    }

    if (
      (startTime >= lunchStart && startTime < lunchEnd) ||
      (lunchStart >= startTime && lunchStart < endTime)
    ) {
      if (shiftHours >= 10) return lunchStart;

      const hoursInLunchPeriod = min(lunchEnd, endTime).diff(max(lunchStart, startTime), "hours").hours;
      if (hoursInLunchPeriod * 2 >= shiftHours) return lunchStart;
    }

    return null;
  };

  return {
    lunch: withinLunch(),
    dinner: withinDinner(),
  };
};
